import { ApiService } from '../../../ApiService';

export class ApplicationFeedService {
  public static cancelTriggerExecution(id: string | number): Promise<void> {
    return ApiService.post(
      `/api/v1/applicant_tracking/application_feeds/${id}/cancel_trigger_execution`,
    );
  }
}
